import {CanvasComponent} from "../canvas/canvas.component";
import Partial = _.Partial;
import {isDefined} from "../../utils/utils";
import {CanvasRenderer, StateInfoItem} from "./stateinfoitemrendererfactory";

/**
 * This class describes the structure of a DispacedElementIssue.
 */
export class DisplacedElementIssue implements StateInfoItem {
    type: string;
    referenceOverDisplaced: boolean;
    showReferenceCrosshair: boolean;
    showDisplacedCrosshair: boolean;

    // TODO: use new typescript feature "Partial" for initializing with Objects
    constructor(type: string, object: any, referenceOverDisplaced?: boolean, showReferenceCrosshair?: boolean, showDisplacedCrosshair?: boolean) {
        this.type = type;
        this.properties = object.properties;
        this.properties.minY = Number.MAX_SAFE_INTEGER;
        this.properties.maxY = 0;

        this.referenceOverDisplaced = referenceOverDisplaced ?? false;
        this.showReferenceCrosshair = showReferenceCrosshair ?? false;
        this.showDisplacedCrosshair = showDisplacedCrosshair ?? false;
    }

    properties: {
        deviationPosition: {
            x: number,
            y: number,
            width: number,
            height: number
        },
        referencePosition: {
            x: number,
            y: number,
            width: number,
            height: number
        },
        minY: number,
        maxY: number
    }
}



/**
 * Renderer that uses a canvas to display displaced elements.
 */
export class DisplacedElementCanvasRenderer implements CanvasRenderer {

    minY: number = Number.MAX_SAFE_INTEGER;
    maxY: number = 0;


    renderRectangle(paperjsScope: any, position: any, color: string, drawCrosshair: boolean) {
        // make sure there are no negative values, since those will not render as expected
        let x = Math.max(position.x, 0);
        let y = Math.max(position.y, 0);

        // adjust width to subtract the part that is off-page
        let width = position.width - (x - position.x);
        let height = position.height - (y - position.y);

        let rect = new paperjsScope.Rectangle(x, y, width, height);
        let path = new paperjsScope.Path.Rectangle(rect);

        path.strokeColor = color;
        path.strokeWidth = 2;
        path.fillColor = new paperjsScope.Color(0.8, 0.8, 1, 0.5);


        if (drawCrosshair) {
            let crosshairLeft = new paperjsScope.Path.Line(
                new paperjsScope.Point(0, y + height / 2),
                new paperjsScope.Point(x, y + height / 2)
            );
            crosshairLeft.strokeColor = color;
            crosshairLeft.strokeWidth = 2;

            let crosshairTop = new paperjsScope.Path.Line(
                new paperjsScope.Point(x + width / 2, 0),
                new paperjsScope.Point(x + width / 2, y)
            );
            crosshairTop.strokeColor = color;
            crosshairTop.strokeWidth = 2;
        }

        // track the highest and lowest boundaries for this issue, to make sure it can be scrolled to properly
        this.minY = Math.min(path.bounds.y, this.minY);
        this.maxY = Math.max(path.bounds.y + path.bounds.height, this.maxY)
    }

    renderToCanvas(issue: DisplacedElementIssue, canvas: CanvasComponent) {
        let scope = canvas.activateAndGetPaperScope();

        this.minY = Number.MAX_SAFE_INTEGER;
        this.maxY = 0;

        if (issue.referenceOverDisplaced){
            if (isDefined(issue.properties.deviationPosition)) {
                this.renderRectangle(scope, issue.properties.deviationPosition, "red", issue.showDisplacedCrosshair);
            }
            if (isDefined(issue.properties.referencePosition)) {
                this.renderRectangle(scope, issue.properties.referencePosition, "blue", issue.showReferenceCrosshair);
            }
        } else {
            if (isDefined(issue.properties.referencePosition)) {
                this.renderRectangle(scope, issue.properties.referencePosition, "blue", issue.showReferenceCrosshair);
            }
            if (isDefined(issue.properties.deviationPosition)) {
                this.renderRectangle(scope, issue.properties.deviationPosition, "red", issue.showDisplacedCrosshair);
            }
        }

        issue.properties.minY = this.minY;
        issue.properties.maxY = this.maxY;
    }

}
